(() => {
  "use strict";
  if (window.PartifyCollectionRepairLoader) {
    window.PartifyCollectionRepairLoader.refresh();
    return;
  }
  const assetPromises = new Map();
  const viewed = new WeakSet();

  function track(event, properties = {}) {
    if (window.Shopify?.theme?.role !== "main" || window.Shopify.designMode) return;
    const root = document.querySelector("[data-pcd-initialized]");
    if (!root) return;
    let config;
    try { config = JSON.parse(root.querySelector("[data-pcd-config]").textContent); }
    catch (_) { return; }
    window.igEvents = window.igEvents || [];
    window.igEvents.push({ event, properties: {
      experience: "parts-and-repairs", collection_handle: config.handle, ...properties,
    } });
  }

  function loadAsset(src, style) {
    const key = (style ? "style:" : "script:") + src;
    if (assetPromises.has(key)) return assetPromises.get(key);
    const promise = new Promise((resolve, reject) => {
      const node = document.createElement(style ? "link" : "script");
      if (style) { node.rel = "stylesheet"; node.href = src; }
      else node.src = src;
      const timeout = setTimeout(() => finish(false), 8000);
      function finish(ok) {
        clearTimeout(timeout);
        node.onload = node.onerror = null;
        if (ok) resolve();
        else {
          node.remove(); assetPromises.delete(key);
          reject(new Error("Collection repair assets unavailable"));
        }
      }
      node.onload = () => finish(true);
      node.onerror = () => finish(false);
      document.head.append(node);
    });
    assetPromises.set(key, promise);
    return promise;
  }

  function failOpen() {
    window.PartifyCollectionDamage?.setEnabled(false);
    document.body?.classList.remove("test--collection-damage", "test--collection-damage-c");
    window.PartifyCollectionDamageTransition?.ready();
  }

  async function refresh() {
    const root = document.querySelector("[data-collection-damage]");
    if (!root) { failOpen(); return; }
    if (root.hasAttribute("data-pcd-initialized")) {
      if (root.hasAttribute("data-pcd-ready")) window.PartifyCollectionDamageTransition?.ready();
      return;
    }
    window.PartifyCollectionDamageTransition?.begin();
    try {
      await Promise.all([
        loadAsset(root.dataset.pcdStylesheet, true),
        loadAsset(root.dataset.pcdScript, false),
      ]);
      if (!root.isConnected) return;
      if (!window.PartifyCollectionDamage) throw new Error("Collection repair module unavailable");
      // Retain the established styling hooks without any experiment assignment.
      document.body.classList.remove("test--collection-damage-b");
      document.body.classList.add("test--collection-damage", "test--collection-damage-c");
      window.PartifyCollectionDamage.setEnabled(true);
      if (!root.hasAttribute("data-pcd-initialized")) throw new Error("Collection repair initialization failed");
    } catch (_) { failOpen(); }
  }

  document.addEventListener("partify:collection-damage:ready", event => {
    const root = event.target.closest?.("[data-pcd-initialized]");
    if (!root || viewed.has(root)) return;
    viewed.add(root); track("collection_damage_view", event.detail);
  });
  document.addEventListener("click", event => {
    const button = event.target.closest("[data-pcd-initialized] button");
    if (!button || button.disabled) return;
    const root = button.closest("[data-pcd-initialized]");
    const areas = [...root.querySelectorAll("[data-pcd-area]:checked")].map(input => input.dataset.pcdArea);
    if (button.hasAttribute("data-pcd-show")) track("collection_damage_show_parts", { areas });
    if (button.hasAttribute("data-pcd-all")) track("collection_damage_browse_all");
    if (button.hasAttribute("data-pcd-edit")) track("collection_damage_edit_areas");
    if (button.hasAttribute("data-pcd-type")) track("collection_damage_refine", { filter: "part_type" });
  }, true);
  document.addEventListener("change", event => {
    if (!event.target.closest("[data-pcd-initialized]")) return;
    if (event.target.hasAttribute("data-pcd-area-filter")) track("collection_damage_refine", { filter: "area" });
    if (event.target.hasAttribute("data-pcd-subtype-filter")) track("collection_damage_refine", { filter: "subtype" });
  }, true);
  window.PartifyCollectionRepairLoader = { refresh };
  document.addEventListener("shopify:section:load", refresh);
  window.addEventListener("pageshow", refresh);
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", refresh, { once: true });
  else refresh();
})();
